// 配置全局访问接口地址
// let commonUrl = "//h5test.ag-lotre.com";
let commonUrl = "https://superkk.flexiisa.top";//优选
 
let baseUrl = {
    commonUrl
}
 
export default baseUrl